import  HeroPage from "../components/herosection/HeroPage";
import FeatureCards from "../components/FeatureCardSection/FeatureCards";
import HowItWorks from "../components/Howitworkssection/HowItWorksSection";
import Testimonials from "../components/Testimonialssections/Testimonials";
import CTASection from "../components/CTASection/CTASection";
import Footer from "../components/Footer/Footer";
import AverageRatingSection from "../components/AverageRatingSection/AverageRatingSection";

export default function Home() {
  return (
    <>
       <HeroPage />
      <FeatureCards />
      <HowItWorks />
      <Testimonials />
      <AverageRatingSection/>
      <CTASection />
      <Footer />
    </>
  );
}
